import { createCrudSlice } from '../createCrudSlice';
import examsService from '@/services/exams.service';

const { reducer, thunks } = createCrudSlice('exams', examsService);
export const { fetchList: fetchExams, createItem: createExam, updateItem: updateExam, deleteItem: deleteExam } = thunks;
export default reducer;
